import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: "#ef8009",
        secondary: "#ead2c3",
        accent: "#f4e6dc",
      },
    },
  },
});
